import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { DashboardLoadStatus } from '@fusion-advantage/formlib'
import { V2L1LoadingIndicator } from '../../Indicator/V2L1LoadingIndicator'

const LoadingRoot = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontSize: '2rem',
})

const ErrorRoot = styled.div(({theme}) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'row',
	...theme.fonts.bodyBold,
	color: theme.colors.stopRed,
	gap: '0.5rem',
}))

interface V2L2DashboardListStatusedContentProps {
	status: DashboardLoadStatus
	children?: ReactNode
}

export const V2L2DashboardListStatusedContent = ({status, children}: V2L2DashboardListStatusedContentProps) => {
	switch(status) {
		case DashboardLoadStatus.Loading:
			return (
				<LoadingRoot>
					<V2L1LoadingIndicator />
				</LoadingRoot>
			)
		case DashboardLoadStatus.Error:
			return (
				<ErrorRoot>
					<FontAwesomeIcon icon={faExclamationTriangle} />
					Error
				</ErrorRoot>
			)
		default:
			return children
	}
}
